export enum TypesOfNavigation {
  Dividend = "Dividend",
  Subscription = "Subscription",
  Orders = "Orders",
}